<!--===============================
=           Starteravatar           =
================================-->
<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="avatar-img" icon v-on="on">
          <img src="../../assets/img/21.jpg" />
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in items1" :key="i">
            <v-list-item-icon>
              <v-icon :color="item.color" v-text="item.img"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "starter-avatar",
  data: () => ({
    items1: [
      {
        text: "Profile",
        img: "mdi-home",
        color: "success"
      },
      {
        text: "Login",
        img: "mdi-lock",
        color: "pink"
      },
      {
        text: "Register",
        img: "mdi-clock",
        color: "pink"
      },
      {
        text: "Home",
        img: "mdi-home",
        color: "blue"
      }
    ],
    items: [
      {
        text: "Real-Time",
        icon: "mdi-clock"
      },
      {
        text: "Audience",
        icon: "mdi-account"
      },
      {
        text: "Conversions",
        icon: "mdi-flag"
      }
    ]
  })
};
</script>
<style scoped>
.avatar-img img {
  width: 32px;
  border-radius: 50%;
}
</style>
<!--===============================
=           Starteravatar  end          =
================================-->
